import React from 'react';
import styles from './Table.module.scss';
import Checkbox from '../Inputs/Checkbox/Checkbox';

const TableHead = ({ data, columns, options, hSelectionAll, selectedLen }) => {
  return (
    <thead className={styles['t_head']} {...options?.thead?.props}>
      <tr>
        {options?.selection?.enable ? (
          <th className={styles["selection"]}>
            <Checkbox
              size="small"
              checked={selectedLen > 0 && selectedLen === data.length}
              indeterminate={selectedLen > 0 && selectedLen !== data.length}
              onChange={hSelectionAll}
              inputProps={{ 'aria-label': 'primary checkbox' }}
              onlyCheckBox={true}
            />
          </th>
        ) : null}

        {columns?.map((c, i) => (
          <th key={i} className={styles['t_h']} {...c?.props?.head}>
            {c.title}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHead;
